import { useaxios } from "../../../utils/useaxios";
export default (customer_name, customer_address, customer_phone, customer_init_loan, user_id) => recaller => setrecaller => initDispatch => clear => {
    // export default (customer_name, customer_address, customer_phone, customer_init_loan, customer_date, user_id) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    initDispatch({ type: 'loadingTrue' });
    useaxios('customer/create.php', { customer_name, customer_address, customer_phone, customer_init_loan, user_id }).then((res) => {
        // useaxios('customer/create.php', { customer_name, customer_address, customer_phone, customer_init_loan, customer_date, user_id }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            initDispatch({ type: 'loadingFalse' });
            return false;
        } else if (res.status == "ok") {
            setrecaller(recaller + 1);
        }
        // setloading(false);
    });
}